<template>
  <div class="country-compare stat-container">
    <div class="head">
      <h2>&nbsp;
        <transition name="fade">
          <span :key="filter.id">{{ filter.label }}</span>
        </transition>
      </h2>
      <transition name="fade">
        <p v-if="filter.id !== 'arbeitskosten' && filter.id !== 'infrastruktur'">
          Zeitliche Entwicklung des Rankings ausgewählter Länder
        </p>
      </transition>
    </div>
      <LineChart :rankings="getRankings()" :countries="selectedCountries" />
  </div>
</template>

<script>
import _ from 'lodash';
import LineChart from '@/components/LineChart.vue';

export default {
  name: 'countrycompare',
  components: {
    LineChart,
  },
  computed: {
    years() {
      return this.$store.state.years;
    },
  },
  mounted: () => {
  },
  methods: {
    getRankings() {
      const stats = this.$store.getters.getRankings(this.filter);
      _.forEach(this.selectedCountries, (sc) => {
        const cId = sc.Id;
        _.forEach(stats, (s, index) => {
          _.find(s, (r, rIndex) => {
            if (r.countryId === cId) {
              stats[index][rIndex].active = 'true';
            }
          });
        });
      });

      let rankings = {};

      _.forEach(stats, (rankingsPerYear) => {
        const activeRankings = _.filter(rankingsPerYear, d => d.active === 'true');
        console.log('activeRankings ', activeRankings)

        _.forEach(activeRankings, (ar) => {
          const c = String(ar.countryId);
          if (!rankings[c]) {
            rankings[c] = new Array();
          }
          rankings[c].push(ar);
        });
      });

      return rankings;
    },
    getBulletClass(countryId) {
      const cIndex = _.findIndex(this.selectedCountries, { Id: countryId }) + 1;
      return (cIndex === 0) ? '' : `bullet-${cIndex}`;
    },
  },
  data: () => ({
  }),
  props: {
    rankings: Array,
    filter: null,
    selectedCountries: null,
  },
};
</script>

<style scoped lang="scss">
.country-compare {
  border: 1px solid $color-border;
  border-radius: $border-radius;
  background-color: $color-bg-widget;

  .rankings {
    padding: $padding-default/2 0;

    @include bp(s) {
      padding: $padding-default/2;
    }

    ul {
      width: 100%;
    }

    li {
      position: relative;
      width: 9%;
      height: 10px;
      display: inline-block;
      text-align: center;
      padding: 5px 0;

    }

    ul.label-y {
      li {
        margin: $padding-default/2 0;
        transform: rotate(-45deg);

        &:first-child {
          transform: rotate(0);
        }
      }
    }

    .line li{
      border-top: 1px solid $color-grey;
      &:first-child {
        border: none;
        text-align: right;
      }
    }

    .line:first-child li{
      border: none;
      &:first-child {
        border: none;
        text-align: right;
      }
    }

    .bullet {
      display: inline-block;
      width: 12px;
      height: 12px;
      background-color: $color-grey;
      border-radius: 50%;
      @extend .animateAll;

      &.active {
        background-color: black;
      }

      span {
        display: block;
        line-height: 16px;
        margin-left: $padding-default;
        white-space: nowrap;
        font-size: 12px;
      }
    }
  }

  .row {
    display: grid;
    grid-template-columns: 35% auto 55%;
    padding-top: $padding-min;
    @extend .animateOpacity;
  }

  .head {
    position: relative;
    height: 31px;
    padding: $padding-default;
    background-color: $color-bg-headline;
    color: $color-text-headline;
    text-align: left;

    p {
      position: absolute;
      top: 50%;
      right: $padding-default;
      max-width: 40%;
      margin: 0;
      text-align: right;
      font-size: 10px;
      transform: translateY(-50%);
    }
  }

  h2 {
    // font-size: 26px;
    //font-size: 24px;
    font-size: 18px;
    justify-self: start;
    text-transform: uppercase;

    span {
      position: absolute;
      top: 50%;
      // width: 70%;
      transform: translateY(-50%);
    }
  }
}
</style>
